import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MainLogo from '../MainLogo';

const PrincipalNavbar = ({ children }) => (
  <Navbar bg="light" expand="lg" fixed="top">
    <Navbar.Brand as={Link} to="/">
      <MainLogo />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    {children}
  </Navbar>
);

export default PrincipalNavbar;
